import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { IconButton, TableCell } from '@mui/material';
import { flexRender } from '@tanstack/react-table';
import classSet from 'react-classset';

const TableHeaderCell = ({ header, paginationDetail, onRequestSort }) => {
  const { style, contentStyle } = header.column.columnDef.meta || {};
  const isSortable = header.column.columnDef?.meta?.sortable;

  return (
    <TableCell
      key={header.id}
      sortDirection={paginationDetail.sortBy === header.id ? (paginationDetail.descending ? 'desc' : 'asc') : false}
      className="header-cell"
      sx={{
        // background: '#f5f5f5',
        // color: '#4B5563',
        // fontWeight: 'bold',
        // fontSize: '12px',
        // border: '1px solid rgba(224, 224, 224, 1)',
        // padding: '6px 8px',
        ...style,
        width: header.column.columnDef.size || 'auto',
        minWidth: header.column.columnDef.size || 'auto',
        maxWidth: header.column.columnDef.size || 'auto',
        cursor: isSortable ? 'pointer' : 'default',
      }}
    >
      <div
        className="thead-content"
        style={{ ...contentStyle }}
        onClick={() => {
          if (isSortable) {
            onRequestSort(header.column);
          }
        }}
      >
        {flexRender(header.column.columnDef.header, header.getContext())}

        {isSortable && (
          <IconButton className="sort-btn">
            <ArrowDropUp
              style={{ top: '-2px' }}
              className={classSet({ active: paginationDetail.sortBy === header.column.id && !paginationDetail.descending })}
            />
            <ArrowDropDown
              style={{ top: '5px' }}
              className={classSet({ active: paginationDetail.sortBy === header.column.id && paginationDetail.descending })}
            />
          </IconButton>
        )}
      </div>
    </TableCell>
  );
};

export default TableHeaderCell;
